import { render, staticRenderFns } from "./Burger.vue?vue&type=template&id=7b87c8ac&scoped=true&"
import script from "./Burger.vue?vue&type=script&lang=js&"
export * from "./Burger.vue?vue&type=script&lang=js&"
import style0 from "./Burger.vue?vue&type=style&index=0&id=7b87c8ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b87c8ac",
  null
  
)

export default component.exports